import i18n from '../i18n';
import ApiStorage from '../redux/ApiStorage';
import { fetchFromUrlPOSTAsync } from '../utils/UrlHelper';
import UtilString from '../utils/utilString';
const URL_INVITE = '/users/invite';
const URL_UPDATE = '/users/update';
const URL_INVITE_UPDATE = '/users/invite/edit';
const URL_INVITE_CONFIRM = '/users/invite/accept';
const URL_INVITE_RESEND = 'users/invite/resend';
const URL_GET_ONE = '/users/get_one';
const URL_GET_ALL = '/users/get_all';
const URL_DELETE = '/users/delete';
const URL_LIST = '/users/list';
const URL_CREATE = '/users/create';
const URL_SET_ACTIVE = '/users/set_active';
const URL_SET_HIDDEN = '/users/set_hidden';

const URL_SIGN_UP_2FA = '/users/2fa/signup';
const URL_SAVE_2FA = '/users/2fa/save';
const URL_TURN_OFF_2FA = '/users/2fa/turn_off';
const URL_VERIFY_2FA = '/users/2fa/verify';

const fs = {
  getAll: async () => {
    const result = await fetchFromUrlPOSTAsync(URL_GET_ALL, {});
    return result;
  },
  fillPaginationList: async (params) => {
    const result = await fetchFromUrlPOSTAsync(URL_LIST, params);
    return result;
  },
  // Admin-side create/update. Unlike `update`, this never touches currentUser,
  // because it is used to edit other users from the users list.
  save: async (values, idKey = null) => {
    if (idKey) {
      return await fetchFromUrlPOSTAsync(`${URL_UPDATE}/${idKey}`, {
        saveData: values,
      });
    }
    return await fetchFromUrlPOSTAsync(URL_CREATE, { saveData: values });
  },
  setActive: async (idKey) => {
    return await fetchFromUrlPOSTAsync(`${URL_SET_ACTIVE}/${idKey}`, {});
  },
  setHidden: async (idKey) => {
    return await fetchFromUrlPOSTAsync(`${URL_SET_HIDDEN}/${idKey}`, {});
  },
  changeStatus: async (idKey, currentStatus) => {
    if (currentStatus === 1) {
      return await fs.setHidden(idKey);
    }
    return await fs.setActive(idKey);
  },
  getOne: async (id) => {
    const result = await fetchFromUrlPOSTAsync(URL_GET_ONE + '/' + id, {});
    return result;
  },
  invite: async (urlParams) => {
    const result = await fetchFromUrlPOSTAsync(URL_INVITE, {
      saveData: urlParams,
    });
    return result;
  },
  updateInvite: async (values, idKey) => {
    const result = await fetchFromUrlPOSTAsync(
      URL_INVITE_UPDATE + '/' + idKey,
      {
        saveData: values,
      }
    );
    return result;
  },
  resendInvite: async (email) => {
    const result = await fetchFromUrlPOSTAsync(URL_INVITE_RESEND, {
      saveData: { email },
    });
    return result;
  },
  inviteConfirm: async (urlParams, _id) => {
    const result = await fetchFromUrlPOSTAsync(URL_INVITE_CONFIRM + '/' + _id, {
      saveData: urlParams,
    });
    if (result.success) {
      ApiStorage.setCurrentUser(result.data);
    }
    return result;
  },
  signUp2Fa: async () => {
    const result = await fetchFromUrlPOSTAsync(URL_SIGN_UP_2FA, {});
    return result;
  },
  turnOff2Fa: async (values) => {
    const result = await fetchFromUrlPOSTAsync(URL_TURN_OFF_2FA, {
      saveData: values,
    });
    if (result.success) {
      ApiStorage.setCurrentUser(result.data);
    }
    return result;
  },
  verify2Fa: async (values) => {
    const result = await fetchFromUrlPOSTAsync(URL_VERIFY_2FA, values);
    if (result.success) {
      result.data.verify2fasuccess = true;
      ApiStorage.setCurrentUser(result.data);
    }
    return result;
  },
  saveUp2Fa: async (values) => {
    const result = await fetchFromUrlPOSTAsync(URL_SAVE_2FA, {
      saveData: values,
    });
    if (result.success) {
      result.data.verify2fasuccess = true;
      ApiStorage.setCurrentUser(result.data);
    }
    return result;
  },
  update: async (values, idKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_UPDATE + '/' + idKey, {
      saveData: values,
    });
    if (result.success) {
      ApiStorage.setCurrentUser(result.data);
    }
    return result;
  },
  changePassword: async (oldPassword, newPassword, idKey) => {
    const url = idKey ? `${URL_UPDATE}/${idKey}` : '/users/change_password';
    return await fetchFromUrlPOSTAsync(url, {
      saveData: {
        oldPassword: UtilString.md5(oldPassword),
        password: UtilString.md5(newPassword),
      },
    });
  },
  delete: async (idKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_DELETE + '/' + idKey, []);
    return result;
  },
};

const loc = {
  getFullListOptions: async (params) => {
    const result = await fs.fillPaginationList(params);
    let options = [];
    if (result?.success) {
      options = result.data.map((obj) => ({
        ...obj,
        value: obj.idUser,
        label: obj.fullName,
      }));
    }
    return options;
  },
  ROLE: {
    SUPERADMIN: 1,
    ADMIN: 2,
  },
  STATUS: {
    PENDING: 1,
    ACTIVE: 2,
    BLOCKED: 3,
  },
  getRoleName: (role) => {
    switch (role) {
      case loc.ROLE.SUPERADMIN:
        return i18n.t('WORD_SUPER_ADMIN');
      case loc.ROLE.ADMIN:
        return i18n.t('WORD_ADMIN');
      default:
        return '---';
    }
  },
  getStatusName: (status) => {
    switch (status) {
      case loc.STATUS.PENDING:
        return { color: 'orange', label: i18n.t('WORD_PENDING') };
      case loc.STATUS.ACTIVE:
        return { color: 'green', label: i18n.t('WORD_ACTIVE') };
      case loc.STATUS.BLOCKED:
        return { color: 'red', label: i18n.t('WORD_BLOCKED') };
      default:
        return '---';
    }
  },
};

const AdminActions = Object.assign(fs, loc);

export default AdminActions;
